import { GetterTree } from 'vuex';
import { IRootState, Direction } from './types';

const rootGetters: GetterTree<IRootState, any> = {
  direction(state): Direction {
    return state.direction;
  },

  hideIgentifyLogo(state): boolean {
    return state.hideIgentifyLogo;
  },

  isLoggedIn(state): boolean {
    return state.isLoggedIn;
  },

  supportsLandscapeWarning(state): boolean {
    return state.supportsLandscapeWarning;
  },
};

export default rootGetters;
